/** P32 (Feb 27, 2026) — shared UI atoms for the Agency Settings page.
 *  Extracted from the original 625-line AgencySettingsPage so each tab
 *  module can stay focused on its own concern.
 */
import React from 'react';
import { CheckCircle, WarningCircle } from '@phosphor-icons/react';

import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';

export function StatusBadge({ ok, labelOk, labelKo }) {
  const okLabel = labelOk || 'Connected';
  const koLabel = labelKo || 'Not configured';
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-[11px] font-mono font-semibold ${
        ok ? 'bg-emerald-100 text-emerald-800 border border-emerald-300'
           : 'bg-amber-100 text-amber-800 border border-amber-300'
      }`}
      data-testid={`status-badge-${ok ? 'ok' : 'ko'}`}
    >
      {ok ? <CheckCircle size={12} weight="fill" /> : <WarningCircle size={12} weight="fill" />}
      {ok ? okLabel : koLabel}
    </span>
  );
}

export function ReadOnlyField({ label, value, mono, testid }) {
  const isMono = mono !== false;
  return (
    <div className="space-y-1">
      <Label className="text-[11px] uppercase tracking-wide text-slate-500">{label}</Label>
      <Input
        value={value == null ? '—' : value}
        readOnly
        className={`bg-slate-50 cursor-not-allowed ${isMono ? 'font-mono text-xs' : ''}`}
        data-testid={testid}
      />
    </div>
  );
}

export const TAXONOMY_PRESETS = [
  { code: '251E00000X', label: 'Home Health Agency' },
  { code: '253Z00000X', label: 'In-Home Supportive Care Agency' },
  { code: '251S00000X', label: 'Community/Behavioural Health Agency' },
  { code: '261QH0100X', label: 'Health Service · Home Health' },
];
